export const en = {
    titre: "Error",
    titreOnglet: "Error | Desjardins",
    "ACC-913": "Your account information can’t be displayed right now. Try again later. (ACC-913)",
    "ACC-914": "Your account information can’t be displayed right now. Try again later. (ACC-914)",
    "FAD-900": {
        titre: "Accord D financing",
        texte: "It’s no longer possible to submit an Accord D financing application. See your other borrowing options with our tool <a href='oel-paas-spa-url/financement/selecteur-produits/'>Find a borrowing solution</a>.",
        estFormatageHtml: true,
        dsdAlertType: "warning",
    },
    GENERIC: "Something went wrong. Try again later. (ACC-999)",
};
